const HOME_PAGE_NAME = 'home';
const DASHBOARD_PAGE_NAME = 'dashboard';
const MY_CREATIONS_PAGE_NAME = 'my-creations';
const OWNED_BLUEPRINTS_PAGE_NAME = 'owned-blueprints';
const ASSET_DETAIL_PAGE_NAME = 'asset-detail';
const MY_OVERVIEW_PAGE_NAME = 'my-overview';
const MY_ACCOUNT_PAGE_NAME = 'my-account';
const MY_ACCOUNT_DETAILS_PAGE_NAME = 'account-details-update';
const MY_SERVERS_PAGE_NAME = 'my-servers';
const ALL_SERVERS_PAGE_NAME = 'all-servers';
const ALL_MY_GAMES_PAGE_NAME = 'all-my-games';
const ALL_COMPOSITIONS_PAGE_NAME = 'all-compositions';
const CREATORS_CLUB_PRIVATE_PAGE_NAME = 'creators-club-private';
const CREATORS_CLUB_PUBLIC_PAGE_NAME = 'creators-club-public';
const JOIN_CREATORS_CLUB_PAGE_NAME = 'join-creators-club';
const MONETIZATION_DETAIL_PAGE_NAME = 'monetization-detail';
const EDIT_ASSET_PAGE_NAME = 'edit-asset';
const REQUEST_CASHBACK_PAGE_NAME = 'request-cashback';

const NOT_FOUND_PAGE_NAME = 'not-found';
const ERROR_PAGE_NAME = 'error';

export {
  HOME_PAGE_NAME,
  DASHBOARD_PAGE_NAME,
  MY_CREATIONS_PAGE_NAME,
  OWNED_BLUEPRINTS_PAGE_NAME,
  ASSET_DETAIL_PAGE_NAME,
  MY_OVERVIEW_PAGE_NAME,
  MY_ACCOUNT_PAGE_NAME,
  MY_SERVERS_PAGE_NAME,
  ALL_SERVERS_PAGE_NAME,
  ALL_MY_GAMES_PAGE_NAME,
  ALL_COMPOSITIONS_PAGE_NAME,
  CREATORS_CLUB_PRIVATE_PAGE_NAME,
  CREATORS_CLUB_PUBLIC_PAGE_NAME,
  JOIN_CREATORS_CLUB_PAGE_NAME,
  MONETIZATION_DETAIL_PAGE_NAME,
  EDIT_ASSET_PAGE_NAME,
  NOT_FOUND_PAGE_NAME,
  ERROR_PAGE_NAME,
  REQUEST_CASHBACK_PAGE_NAME,
  MY_ACCOUNT_DETAILS_PAGE_NAME,
};
